import { useMemo } from "react";
import MassFlow from "../../components/massFlow";
import { MassFlowConfig } from "../../components/massFlow/types";
import { blocoMassColumns } from "../columns";
import { validateBloco } from "../validation";
import { blocosFromCsv, downloadCsvTemplate } from "./csv";
import { Bloco, BLOCO_FIELDS, emptyBloco } from "../types";

export interface MassBlocosProps {
  blocos: Bloco[];
  search: string;
  onSearchChange: (value: string) => void;
  onBack: () => void;
  onSaved: () => Promise<void> | void;
}

export default function MassBlocos(props: MassBlocosProps) {
  const { blocos, search, onSearchChange, onBack, onSaved } = props;

  const config = useMemo<MassFlowConfig>(
    () => ({
      tableId: "blocosMassFlow",
      endpoint: "/easyFlow2.0/blocos",
      entity: {
        singular: "bloco",
        plural: "blocos",
        gender: "m",
      },
      searchPlaceholder: "Pesquisar blocos",
      fields: BLOCO_FIELDS,
      emptyValues: emptyBloco,
      columns: blocoMassColumns,
      validate: validateBloco,
      csv: {
        onDownloadTemplate: downloadCsvTemplate,
        parse: blocosFromCsv,
      },
    }),
    [],
  );

  return (
    <MassFlow
      config={config}
      records={blocos}
      search={search}
      onSearchChange={onSearchChange}
      onBack={onBack}
      onSaved={onSaved}
    />
  );
}
